module.exports = "<div *ngIf=\"src.url\" class=\"video-container\" [@fade]=\"show\" (@fade.done)=\"animationDone($event)\">\n        <vg-player (onPlayerReady)=\"onPlayerReady($event)\">\n            <video #media [vgMedia]=\"media\" [vdgmHls]=\"src.url\" muted preload=\"auto\" crossorigin webkit-playsinline playsinline></video>\n        </vg-player>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/video-player/micro-video-player.template.html
// module id = 785
// module chunks = 2